import React from 'react'
import bbcode, { Tag } from 'bbcode-to-react'

class Paragraph extends Tag {
  toReact() {
    return (
      <p>{this.getComponents()}</p>
    );
  }
}

class Figure extends Tag {
  toReact() {
    return (
      <figure>{this.getComponents()}</figure>
    );
  }
}

bbcode.registerTag('p', Paragraph);
bbcode.registerTag('figure', Figure);